import OverlapPicker from '@/components/OverlapPicker';

export default {
    components: {
        OverlapPicker,
    },
    data() {
        return {
            overlapFeatures: [],
            showOverlapPicker: false,
        };
    },
};



// WEBPACK FOOTER //
// ./src/mixins/overlapPicker.js